import { Component } from 'react'
import { IInputFormikProps, InputFormik as InputDefault } from './Input'
import { SearchInputFormik } from './Search'
import { NumberInputFormik } from './Number'
import { TextareaFormik } from './Textarea'
import TimePicker from './TimePicker'
import { Input as UIInput } from '@nextretreat/ui-components/dist/Input'
import { SelectFormik } from './Select'

export class Input extends Component<IInputFormikProps> {
  static Checkbox = UIInput.Checkbox
  static Number = NumberInputFormik
  static Search = SearchInputFormik
  static Select = SelectFormik
  static TimePicker = TimePicker
  static Textarea = TextareaFormik

  render() {
    return <InputDefault {...this.props} />
  }
}
